var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"dark":"","id":"MPCRoot","title":"Main Content"}},[_c('mpc-page-header'),_c('main',[_c('v-content',[_c('router-view')],1)],1),_c('mpc-page-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }